var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.isChildren ? '':'row']},_vm._l((_vm.row.cols),function(item,index){return _c('WebPartPageCol',{key:index,attrs:{"rows":item.rows,"colWidth":item.colWidth,"webPartItem":item.item,"templateName":_vm.templateName,"isChildren":_vm.isChildren}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }